/**
 * Utility functions for artifacts
 *
 * Re-exports from the shared package to maintain a single source of truth.
 * This ensures artifact type constants and display names stay in sync across frontend and backend.
 */

// Re-exported from the shared modules that declare them, the single source of truth
export {
  getArtifactDisplayName,
  getArtifactOperationMessage,
  getArtifactOperationDescription,
  getArtifactTypeConfig,
  isValidArtifactType,
} from '@bower/shared/constants/artifact';
export {
  ARTIFACT_TYPES,
  ARTIFACT_TYPE_CONFIG,
} from '@bower/shared/constants/artifact-types.generated';
export { UNTITLED_ARTIFACT_DISPLAY } from '@bower/shared/utils/artifactDisplayTitle';

import { resolveArtifactDisplayTitle } from '@bower/shared/utils/artifactDisplayTitle';

export type { ArtifactType } from '@bower/shared';

/**
 * Returns the display title for an artifact.
 *
 * Semantic titles take precedence over the original attachment filename. This
 * keeps attachments identifiable while an asynchronous title is still pending.
 */
export function getDisplayTitle(
  title: string | null | undefined,
  fileName?: string | null,
): string {
  return resolveArtifactDisplayTitle(title, { fileName });
}
